 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account":"account","accounts":"accounts","billing":"billing","changePassword":"changePassword","collectionCreate":"collectionCreate","collections":"collections","creditRequestCreate~downloads~order~orderCreate~orderCreateSend~orderReturn~orderUpdate~products~sec~3ac9a26f":"creditRequestCreate~downloads~order~orderCreate~orderCreateSend~orderReturn~orderUpdate~products~sec~3ac9a26f","creditRequestCreate~order~orderCreate~orderReturn~orderUpdate~ticketResolve~upload":"creditRequestCreate~order~orderCreate~orderReturn~orderUpdate~ticketResolve~upload","creditRequestCreate~orderCreate~orderReturn~orderUpdate~upload":"creditRequestCreate~orderCreate~orderReturn~orderUpdate~upload","creditRequestCreate":"creditRequestCreate","orderCreate~orderReturn~orderUpdate":"orderCreate~orderReturn~orderUpdate","orderCreate":"orderCreate","orderReturn":"orderReturn","orderUpdate":"orderUpdate","upload":"upload","downloads~order~orderCreateSend~products~security~swiftplusstatement~transaction":"downloads~order~orderCreateSend~products~security~swiftplusstatement~transaction","order":"order","downloads":"downloads","orderCreateSend":"orderCreateSend","products":"products","security":"security","swiftplusstatement":"swiftplusstatement","transaction":"transaction","ticketResolve":"ticketResolve","notFound":"notFound","orderTickets":"orderTickets","orders":"orders","pendingOrders":"pendingOrders","practices":"practices","profile":"profile","referral":"referral","register":"register","resetPassword":"resetPassword","shadeMatch":"shadeMatch","signin":"signin","signinOTP":"signinOTP","statements":"statements","stationery":"stationery","stationeryCreate":"stationeryCreate","swiftplus":"swiftplus"}[chunkId]||chunkId) + "." + {"account":"337de0a5","accounts":"34b192ea","billing":"3ea21219","changePassword":"fc3e974d","collectionCreate":"94284c75","collections":"f3484f8f","creditRequestCreate~downloads~order~orderCreate~orderCreateSend~orderReturn~orderUpdate~products~sec~3ac9a26f":"168e4d40","creditRequestCreate~order~orderCreate~orderReturn~orderUpdate~ticketResolve~upload":"7091a3a3","creditRequestCreate~orderCreate~orderReturn~orderUpdate~upload":"37817d01","creditRequestCreate":"0372b2cf","orderCreate~orderReturn~orderUpdate":"cc060ea8","orderCreate":"11a9a6fe","orderReturn":"dbb29ee9","orderUpdate":"37ea4e70","upload":"da649a12","downloads~order~orderCreateSend~products~security~swiftplusstatement~transaction":"2b8b3724","order":"a3690639","downloads":"aceffc12","orderCreateSend":"63d401ae","products":"c5b066f4","security":"6d1cdd53","swiftplusstatement":"0ef77bd8","transaction":"9b089a8b","ticketResolve":"d8467293","notFound":"aff74661","orderTickets":"265e6918","orders":"a83f3361","pendingOrders":"72ff4cbd","practices":"ee135d60","profile":"027b9778","referral":"ed48619a","register":"ec52c0fe","resetPassword":"e129247e","shadeMatch":"1228faa6","signin":"0d50755b","signinOTP":"fd80409b","statements":"de55cccb","stationery":"813fe83f","stationeryCreate":"7eddd3d1","swiftplus":"037ce8db"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account":1,"accounts":1,"billing":1,"changePassword":1,"collections":1,"creditRequestCreate~order~orderCreate~orderReturn~orderUpdate~ticketResolve~upload":1,"creditRequestCreate~orderCreate~orderReturn~orderUpdate~upload":1,"creditRequestCreate":1,"orderCreate~orderReturn~orderUpdate":1,"orderCreate":1,"orderReturn":1,"orderUpdate":1,"upload":1,"order":1,"downloads":1,"orderCreateSend":1,"products":1,"security":1,"swiftplusstatement":1,"transaction":1,"ticketResolve":1,"notFound":1,"orderTickets":1,"orders":1,"pendingOrders":1,"practices":1,"profile":1,"referral":1,"register":1,"resetPassword":1,"signin":1,"statements":1,"stationery":1,"stationeryCreate":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account":"account","accounts":"accounts","billing":"billing","changePassword":"changePassword","collectionCreate":"collectionCreate","collections":"collections","creditRequestCreate~downloads~order~orderCreate~orderCreateSend~orderReturn~orderUpdate~products~sec~3ac9a26f":"creditRequestCreate~downloads~order~orderCreate~orderCreateSend~orderReturn~orderUpdate~products~sec~3ac9a26f","creditRequestCreate~order~orderCreate~orderReturn~orderUpdate~ticketResolve~upload":"creditRequestCreate~order~orderCreate~orderReturn~orderUpdate~ticketResolve~upload","creditRequestCreate~orderCreate~orderReturn~orderUpdate~upload":"creditRequestCreate~orderCreate~orderReturn~orderUpdate~upload","creditRequestCreate":"creditRequestCreate","orderCreate~orderReturn~orderUpdate":"orderCreate~orderReturn~orderUpdate","orderCreate":"orderCreate","orderReturn":"orderReturn","orderUpdate":"orderUpdate","upload":"upload","downloads~order~orderCreateSend~products~security~swiftplusstatement~transaction":"downloads~order~orderCreateSend~products~security~swiftplusstatement~transaction","order":"order","downloads":"downloads","orderCreateSend":"orderCreateSend","products":"products","security":"security","swiftplusstatement":"swiftplusstatement","transaction":"transaction","ticketResolve":"ticketResolve","notFound":"notFound","orderTickets":"orderTickets","orders":"orders","pendingOrders":"pendingOrders","practices":"practices","profile":"profile","referral":"referral","register":"register","resetPassword":"resetPassword","shadeMatch":"shadeMatch","signin":"signin","signinOTP":"signinOTP","statements":"statements","stationery":"stationery","stationeryCreate":"stationeryCreate","swiftplus":"swiftplus"}[chunkId]||chunkId) + "." + {"account":"0edca0be","accounts":"868700cc","billing":"b2ffbd8e","changePassword":"27f1d4be","collectionCreate":"31d6cfe0","collections":"9100c606","creditRequestCreate~downloads~order~orderCreate~orderCreateSend~orderReturn~orderUpdate~products~sec~3ac9a26f":"31d6cfe0","creditRequestCreate~order~orderCreate~orderReturn~orderUpdate~ticketResolve~upload":"28475cc4","creditRequestCreate~orderCreate~orderReturn~orderUpdate~upload":"5f0a1fca","creditRequestCreate":"e2603cc6","orderCreate~orderReturn~orderUpdate":"0be36d5c","orderCreate":"3abb2e07","orderReturn":"fe7e2cd3","orderUpdate":"f276478a","upload":"0033d0bf","downloads~order~orderCreateSend~products~security~swiftplusstatement~transaction":"31d6cfe0","order":"c156f358","downloads":"46ed1d88","orderCreateSend":"36c1c14b","products":"c077cebb","security":"ef238a86","swiftplusstatement":"da985a21","transaction":"c3daaa83","ticketResolve":"300e4b28","notFound":"d5d565fb","orderTickets":"6bb935cd","orders":"2b70468e","pendingOrders":"13ad3287","practices":"483f2512","profile":"493eb30d","referral":"2d17938c","register":"27f1d4be","resetPassword":"d5d565fb","shadeMatch":"31d6cfe0","signin":"d5d565fb","signinOTP":"31d6cfe0","statements":"7d23b3ae","stationery":"3a41c139","stationeryCreate":"9bc9bccb","swiftplus":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
